import React from 'react';
import { Logo } from './ui/Logo';
import { InstagramIcon, FacebookIcon, TikTokIcon } from './ui/SocialIcons';

// Componente pulsante sociale "Carino" con Glow Effect
const SocialButton = ({ href, icon, label }: { href: string; icon: React.ReactNode; label: string }) => (
  <a 
    href={href} 
    target="_blank" 
    rel="noopener noreferrer"
    aria-label={label}
    className="group relative flex items-center justify-center w-12 h-12 rounded-full bg-zinc-900 border border-white/10 text-zinc-400 transition-all duration-300 hover:scale-110 hover:-translate-y-1 hover:bg-white hover:text-black hover:border-white hover:shadow-[0_0_25px_rgba(255,255,255,0.6)]"
  >
    <div className="transform transition-transform duration-300 group-hover:rotate-12">
        {icon}
    </div>
  </a>
);

export const Footer: React.FC = () => {
  return (
    <footer className="bg-black border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 mb-16">
          
          <div className="max-w-sm">
            <a href="#" className="flex items-center gap-2 mb-6 group" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                <Logo className="w-8 h-8 text-white group-hover:rotate-12 transition-transform" />
                <span className="text-2xl font-bold tracking-tighter text-white">MOON DIGITAL AGENCY</span>
            </a>
            <p className="text-gray-400">
              Produciamo contenuti, generiamo risultati, facciamo crescere il tuo business.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <h4 className="font-bold text-white text-lg">Seguici sui Social</h4>
            
            {/* Social Icons Framework */}
            <div className="flex items-center gap-4">
               <SocialButton 
                 href="https://www.instagram.com/moon_digitalagency/" 
                 label="Instagram"
                 icon={<InstagramIcon size={20} />} 
               />
               <SocialButton 
                 href="https://www.facebook.com/moonproject5" 
                 label="Facebook"
                 icon={<FacebookIcon size={20} />} 
               />
               <SocialButton 
                 href="https://www.tiktok.com/@moondigitalagency.it" 
                 label="TikTok"
                 icon={<TikTokIcon size={20} />} 
               />
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-white/10 text-sm text-gray-500">
          <p>© 2026 Moon Digital Agency. All rights reserved. — P.IVA 02052530439</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};